import GuestLayout from 'content/layouts/Guest/GuestLayout';
import { RouteObject } from 'react-router-dom';
import loginRouter from './Login';
import passwordRouter from './Password';
const guestRouter: RouteObject = {
  element: <GuestLayout />,
  children: [...loginRouter, ...passwordRouter],
};

export default guestRouter;
